export default __webpack_public_path__ + "static/media/empl_direct_indirect.ea4933ca.svg";